import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';
import i18n from "shared/i18n";

import {connect} from "react-redux";
import { patchCatalogDescription } from 'redux/catalog/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './CatalogName.css';

const ENTER_KEY = 13;


class CatalogName extends Component {
  static propTypes = {
    patchCatalogDescription: PropTypes.func.isRequired,
    catalogDescription: PropTypes.object,
    patchCatalogDescriptionError: PropTypes.object,
    location: PropTypes.object.isRequired,
  };

  static defaultProps = {
    catalogDescription: null,
    patchCatalogDescriptionError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.catalogDescription) {
      this.setState({
        initialValue: this.props.catalogDescription.name,
        currentValue: this.props.catalogDescription.name,
      });
    }

    if (this.props.location) {
      const isCatalogNameFocused = this.useQuery(this.props.location.search);
      if (isCatalogNameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.catalogDescription &&
      prevProps.catalogDescription.name &&
      prevProps.catalogDescription.name !== this.props.catalogDescription.name
    ) {
      this.setState({ currentValue: this.props.catalogDescription.name });
    }

    if (prevProps.location !== this.props.location) {
      const isCatalogNameFocused = this.useQuery(this.props.location.search);
      if (isCatalogNameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeCatalogName = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('name', currentValue);
      this.props.patchCatalogDescription(
        this.props.catalogDescription.id,
        form,
      );
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeCatalogName();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeCatalogName();
  };

  executeValidation = () => {
    const { patchCatalogDescriptionError } = this.props;

    const { currentValue } = this.state;
    if (patchCatalogDescriptionError && patchCatalogDescriptionError.name) {
      return patchCatalogDescriptionError.name;
    }
    if (currentValue === '' ) {
      return i18n.t("Store name should not be empty");
    }
    return null;
  };

  render() {
    const { catalogDescription } = this.props;
    const { currentValue } = this.state;

    if (!catalogDescription) return null;

    return (
      <Translation>
        {(t) => (
          <div className="catalog-name__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">{t("Store Name")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    catalogDescription: state.catalogReducer.catalogDescription,
    patchCatalogDescriptionError: state.catalogReducer.patchCatalogDescriptionError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCatalogDescription,
  },
)(onClickOutside(CatalogName));
